
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum TaskflowStatus {
	Inactive = 0,
	Active = 1,
	Completed = 2
}
export namespace TaskflowStatus {
	export function getKeys(): Map<TaskflowStatus, string> {
		return new Map([[0, 'Inactive'], [1, 'Active'], [2, 'Completed']]);
	}
}
